<template>
	<BModal>
		<p class="fsz-xl color-neutral-700 mb-60">
			{{ $t("Alterar detalhes") }}
		</p>

		<div class="o-stack mb-60">
			<BFieldBlock :label="$t('Nome simulação')"
				><BFieldText maxlength="25" v-model="newSimulationName"
			/></BFieldBlock>
			<BFieldBlock :label="$t('Projeto')"
				><BFieldText maxlength="25" v-model="newProject" />
			</BFieldBlock>
		</div>

		<div
			class="modalFooter flex justify-end"
			:style="{
				gap: '16px',
			}"
		>
			<BBtn size="l" variant="text" @click="() => $emit('close')">{{
				$t("Cancelar")
			}}</BBtn>
			<BBtn
				size="l"
				@click="handleSaveDetailsBtnClick"
				:disabled="!isSaveDetailsBtnEnabled"
				>{{ $t("Salvar") }}</BBtn
			>
		</div>
	</BModal>
</template>

<script>
import BBtn from "@/components/base/BBtn.vue";
import BIcon from "@/components/base/BIcon/index.vue";
import BModal from "@/components/base/BModal.vue";
import BFieldBlock from "@/components/base/BFieldBlock.vue";
import BFieldText from "@/components/base/BFieldText.vue";

export default {
	components: {
		BBtn,
		BIcon,
		BModal,
		BFieldBlock,
		BFieldText,
	},
	props: {
		simulationName: {
			type: String,
			required: true,
		},
		project: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			newSimulationName: this.simulationName,
			newProject: this.project,
		};
	},
	computed: {
		isSaveDetailsBtnEnabled() {
			return this.simulationName.trim().length && this.project.trim().length;
		},
	},
	methods: {
		handleSaveDetailsBtnClick() {
			this.$emit("save", {
				simulationName: this.newSimulationName,
				project: this.newProject,
			});
		},
	},
};
</script>

<style scoped>
@media (max-width: 580px) {
	.modalFooter {
		flex-direction: column-reverse;
	}
}
</style>
